import { Wording } from '@/types';

export const COOKING_WORDING_LT: Wording = {
  components_header_media_content: 'Maisto gaminimo vaizdo įrašai',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Receptai',
  components_header_text2: 'Dienoraštis',
  components_header_members: 'Nariai',
  hero_text: 'Virkite su aistra, valgykite su džiaugsmu',
  hero_button_text: 'Pradėkite gaminti šiandien',
  components_ressources_section_title: 'IŠTEKLIAI',
  components_ressources_subheader_text: 'Visi ištekliai, kurių jums reikia norint mokytis, gaminti ir kurti geresnį maistą',
  components_ressources_span_text: 'Atraskite gausią vaizdo receptų kolekciją, išsamius maisto gaminimo vadovus ir ekspertų įžvalgas apie skonių derinimą, maisto pateikimą ir kulinarinį kūrybiškumą.',
  components_ressources_card_1_title: 'Įkvėpimas maisto gaminimui',
  components_ressources_card_1_text: 'Įkvėpkite kūrybingų receptų ir maisto gaminimo vaizdo įrašų.',
  components_ressources_card_2_title: 'Kulinarijos žinios',
  components_ressources_card_2_text: 'Sužinokite pagrindinius maisto gaminimo būdus, skonių derinius ir maisto derinimo pagrindus naudodamiesi aiškiais ir praktiškais vadovais.',
  components_ressources_link: 'Žiūrėti vaizdo įrašus',
  components_notes_and_google_title_1: 'Kulinarijos mokymai',
  components_notes_and_google_title_2: 'Kasdienis maisto gaminimas',
  components_notes_and_google_title_3: 'Nuolatiniai maisto gaminimo įgūdžiai',
  components_review_google_text: 'Atsiliepimai „Google“ sistemoje',
  media_content_section_title: 'Maisto gaminimo vaizdo įrašai',
  media_content_section_subheader_text: 'Naršykite receptus ir žingsnis po žingsnio maisto gaminimo vaizdo įrašus.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Daugiau vaizdo įrašų',
  text2_section_title: 'BLOGAS',
  text2_section_subheader_text: 'Vadovai ir straipsniai',
  text2_section_button_more: 'Daugiau straipsnių',
  components_text1_section_title: 'RECEPTAI',
  components_text1_subheader_text: 'Skanūs receptai kasdieniam maisto gaminimui',
  components_text1_span_text: 'Atraskite lengvai suprantamus receptus, skirtus kasdieniams patiekalams, aiškius veiksmus ir puikius rezultatus.',
  components_text1_card_1_title: 'Pradėkite savo dieną teisingai',
  components_text1_card_1_text: 'Paprasti ir skanūs receptai, padėsiantys pradėti dieną lengvai ir skaniai.',
  components_text1_card_3_title: 'Skanūs pietų idėjos',
  components_text1_card_3_text: 'Skanūs pietų receptai, kuriuos lengva paruošti ir kurie kupini skonio.',
  components_text1_card_2_title: 'Jaukinantys vakarienės receptai',
  components_text1_card_2_text: 'Šilti, sotūs vakarienės receptai, puikiai tinkantys ramiems vakarams namuose.',
  components_text1_link: 'Peržiūrėti visus receptus',
  components_footer_text: 'Išmokite geriau gaminti, kurkite geresnį maistą: jūsų virtuvė, jūsų kelionė.',
  components_footer_info: 'Informacija',
  components_footer_registration_number: 'Registracijos numeris',
  components_footer_legal: 'Teisinis',
  components_footer_terms: 'Sąlygos ir nuostatos',
  components_footer_privacy: 'Privatumo politika',
  button_load_more: 'Įkelti daugiau',
  page_media_1_content_hero_text: 'Atraskite paprastus maisto gaminimo vaizdo įrašus kiekvienam skoniui',
  page_text1_hero_text: 'Receptai',
  page_text1_section_title: 'Maisto gaminimo patarimai',
  page_text1_subheader_text: 'Receptai',
  page_text2_hero_text: 'Mūsų tinklaraštis',
  page_text2_section_title: 'Dienoraštis',
  page_text2_subheader_text: 'Vadovai ir straipsniai',
  enter_email_title: 'Norėdami tęsti, įveskite savo el. pašto adresą',
  enter_email_placeholder_email: 'El. paštas',
  enter_email_button_enter: 'Įeiti',
  components_login_success_text: 'Prisijungimas sėkmingas!',
  components_card_link_media_content: 'Žiūrėti dabar',
  components_card_link_text1_content: 'Peržiūrėti receptą',
  components_card_link_text2_content: 'Peržiūrėti straipsnį',
};